module.exports = __webpack_public_path__ + "img/355.2fa447a0.jpg";